/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-organization.html';

import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';

/**
 * @import { PropType } from 'vue'
 * @import { Organization } from './setup-manager'
 */

export default defineComponent({
  name: 'SetupOrganization',
  template,
  components: { SetupHeader },
  directives: { focus },
  emits: {
    back() {},
    /**
     * @param {Organization} organization
     */
    submit(organization) {}
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
    /**
     * @param {Organization} organization
     */
    onSubmit(organization) {
      this.$emit('submit', organization);
    }
  },
  props: {
    isOnline: { type: Boolean, required: true },
    organizationArray: {
      /** @type {PropType<Organization[]>} */
      type: Array,
      required: true
    }
  }
});
